import React from "react";

export const eurf = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);

export const fmtLastSeen = (iso) => {
  if (!iso) return { label: "Jamais", tint: "text-zinc-600" };
  const d = new Date(iso); const diff = Math.floor((Date.now() - d.getTime()) / 60000);
  let label;
  if (diff < 1) label = "À l'instant";
  else if (diff < 60) label = `il y a ${diff} min`;
  else if (diff < 1440) label = `il y a ${Math.floor(diff / 60)} h`;
  else if (diff < 43200) label = `il y a ${Math.floor(diff / 1440)} j`;
  else label = d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  const tint = diff < 15 ? "text-emerald-400" : diff < 10080 ? "text-zinc-300" : "text-amber-400";
  return { label, tint };
};

export const STATUS = ["none", "trial", "active", "past_due", "canceled"];
export const STATUS_LABELS = { none: "Aucun", trial: "Essai", active: "Actif", past_due: "Impayé", canceled: "Résilié" };
export const PIE_COLORS = { none: "#52525b", trial: "#FFD500", active: "#FF6A00", past_due: "#f87171", canceled: "#3f3f46" };
export const PERM_LEVELS = [["none", "Aucun"], ["read", "Lecture"], ["write", "Écriture"]];
export const tipStyle = { background: "#18181b", border: "1px solid #3f3f46", borderRadius: 12, color: "#fff", fontSize: 12 };

export function Kpi({ icon: Icon, label, value, sub, tint }) {
  return (
    <div data-testid={`sa-kpi-${label}`} className="rounded-2xl border border-zinc-800 bg-zinc-950 p-5">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-wide text-zinc-500">{label}</span>
        <span className="flex h-9 w-9 items-center justify-center rounded-xl" style={{ background: `${tint}1a`, color: tint }}><Icon className="h-4.5 w-4.5" /></span>
      </div>
      <p className="mt-3 font-display text-3xl font-bold text-white">{value}</p>
      {sub && <p className="mt-0.5 text-xs text-zinc-500">{sub}</p>}
    </div>
  );
}

export function Panel({ title, children }) {
  return (
    <div className="rounded-2xl border border-zinc-800 bg-zinc-950 p-5">
      <h3 className="mb-4 text-sm font-semibold text-zinc-300">{title}</h3>
      {children}
    </div>
  );
}
